<div [ngClass]="{'open': info.open}" class="accordion-item">
	<div (click)="toggleAccordion()" class="accordion-header">
		<i class="fal fa-{{info.icon}}"></i>
		<span>{{info.name | translate}}</span>
		<i [ngClass]="{'fa-minus-circle': info.open, 'fa-plus-circle': !info.open}" class="fal toggle-accordion"></i>
	</div>
	<div *ngIf="info.open" class="accordion-content">
		<p [innerHTML]="info.description | translate"></p>
		<a *ngIf="info.router" [routerLink]="['/'+info.router]">{{'landing/know-more' | translate}} <i
			class="fal fa-chevron-right"></i></a>
	</div>
</div>
